import React from "react";
// import Calendar from "@material-ui/icons/CalendarToday";

import LogoProyecto from "./../../images/ALCALDIA-80px.png";
import LogoCliente from "./../../images/GRANADA-80px.png";
import LogoPonal from "./../../images/EscudoPolicia.png";
import LogoOACYS from "./../../images/LogoOACYS.jpg";

function InformPageComponent(props) {
  return (
    <>
      {/*PROPUESTA ENCABEZADO 02*/}
      <div className="work-sheet-city-card-3" name={props.ancla}>
        <div className="line line-100">
          <div className="content-line ">
            {/* <div className="line line-5"></div> */}
            <div
              className="line line-25 logo-inform"
              style={{ fontSize: "20px" }}
            >
              <div className="line line-40">
                <img src={LogoProyecto} alt="Logo proyecto" />
              </div>

              <div className="line line-60 ">Alcaldía de Granada</div>
            </div>
            <div className="line line-50 text-center">
              <h2 className="font-n margin-13">BOLETÍN DE SEGURIDAD</h2>
              <span>{props.fecha}</span>

              {/* <h5>{`Página ${props.day} de 8`}</h5> */}
            </div>
            <div className="line line-25">
              <img
                src={LogoCliente}
                className="image-left"
                alt="Logo cliente"
              />
            </div>
            <hr size="4px" color="black" />
            <div className="line line-33">No. 001</div>
            <div className="line line-33">Granada marzo 10, 2021</div>
            <div className="line line-33">
              Fuente:SIEDCO - SECAD a corte 16 de marzo
            </div>

            <hr></hr>
            {/* <div className="line line-5"></div> */}
            {/* <div className="min-heigth line line-100 border-button-prymary "></div> */}
          </div>
        </div>
        {props.children}
        <div className="line line-100">
          <div className="content-line ">
            <div className="line line-15"></div>
            <div
              className="line line-25 logo-inform"
              style={{ fontSize: "15px" }}
            >
              <div className="line line-30 ">
                <img
                  src={LogoPonal}
                  alt="Logo proyecto"
                  style={{ width: "60px" }} 
                />
              </div>

              <div className="line line-70 ">
                <div>SOMOS UNO.</div>
                <div>SOMOS TODOS.</div>
              </div>
            </div>
            <div className="line line-20 text-center">
              <div>ALTA CONSEJERÍA PARA</div>
              <div>LA SEGURIDAD</div>
              <div>CIUDADANA</div>
            </div>
            <div className="line line-20">
              <img src={LogoOACYS} className="image-left" alt="Logo cliente" />
            </div>
            <div className="line line-20"></div>
            {/* <div className="min-heigth line line-100 border-button-prymary "></div> */}
          </div>
        </div>
      </div>
      {/*PROPUESTA ENCABEZADO 01*/}
      {/* <div className="work-sheet-city-card-3" name={props.ancla}>
        <div className="line line-100">
          <div className="content-line ">
            <div className="line line-5"></div>
            <div className="line line-25">
              <img src={LogoProyecto} alt="Logo proyecto" />
            </div>
            <div className="line line-40 text-center">
              <h2 className="font-20 margin-13">{props.title}</h2>
              <span>{props.fecha}</span> */}
              {/* <span>{`27 de enero de 2021 `}</span> */}
              {/* <hr></hr> */}
              {/* <span>{`Boletín N° ${props.day} `}</span> */}
              {/* <span>{`Análisis realizado el `}</span> */}
              {/* <span>{`N° ${props.day}`}</span> */}
              {/* <h5>{`Página ${props.day} de 8`}</h5> */}
              {/* <span>
                <Calendar className="primary-color vertical-aligna-sub" />
                {props.title}
              </span> */}
            {/* </div>
            <div className="line line-25">
              <img
                src={LogoCliente}
                className="image-left"
                alt="Logo cliente"
              />
            </div>
            <div className="line line-5"></div>
            <div className="min-heigth line line-100 border-button-prymary "></div>
          </div>
        </div>
        {props.children}
      </div> */}
    </>
  );
}

export default InformPageComponent;
